import { render, staticRenderFns } from "./AppointmentsClient.vue?vue&type=template&id=5c9653ac&"
import script from "./AppointmentsClient.vue?vue&type=script&lang=js&"
export * from "./AppointmentsClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports